  // src/services/NotificationService.js - WITH TOKEN REFRESH & VALIDATION

  import { messaging, getToken, onMessage, deleteToken } from './firebaseConfig';
  import { doc, updateDoc, getDoc } from 'firebase/firestore';
  import { db } from './firebaseConfig';

  class NotificationService {
    constructor() {
      this.token = null;
      this.vapidKey = 'BP8d_2yy0G3JCUXlwhrCFso-yQ2zK-0DMVfoy0x-5AJvKpG-D77oa1RYFPAJrh4gS4Qhlnhyu-8Pe6eW7DOWruc';
      this.audio = null;
      this.audioInitialized = false;
      this.pendingSound = false;
      this.initAudioData();
    }

    initAudioData() {
      const audioData = 'data:audio/wav;base64,UklGRvQGAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAZGF0YdAGAAD/////AgD9/wMA/P8EAPv/BQD6/wcA+P8IAPf/CgD1/wwA8/8OAPn/DwD7/w8A/f8NAP//CwD//wkA//8HAP//BQD+/wMA/v8CAP7/AQD+/wAA/v////7////9/////f////3//v/9//7//f/+//3//f/9//3//f/9//3//P/9//z//f/8//3/+//9//v//P/7//z/+//8//v/+//7//v/+//7//v/+v/7//r/+//6//r/+v/6//r/+f/6//n/+v/5//n/+f/5//n/+P/5//j/+f/4//j/+P/4//j/+P/4//f/+P/3//j/9//3//f/9//3//f/9//3//f/9v/3//b/9//2//b/9v/2//b/9v/2//b/9v/2//b/9v/2//X/9v/1//b/9f/2//X/9f/1//X/9f/1//X/9f/1//X/9f/1//X/9f/1//X/9f/1//X/9f/1//X/9f/1//X/9f/1//X/9v/1//b/9f/2//b/9v/2//b/9v/2//b/9//2//f/9//3//f/9//3//f/+P/3//j/+P/4//j/+P/5//j/+f/5//n/+f/5//n/+v/5//r/+v/6//r/+v/6//v/+v/7//v/+//7//v/+//8//v//P/8//z//P/8//z//f/8//3//f/9//3//f/9//7//f/+//7//v/+//7//v////7/////////////////////////////////////////AQD//wEA//8BAP//AgD+/wIA/v8CAP7/AgD+/wMA/f8DAP3/AwD9/wQA/P8EAPz/BAD8/wQA/P8FAPv/BQD7/wUA+/8FAPv/BgD6/wYA+v8GAPr/BgD6/wcA+f8HAPn/BwD5/wcA+f8IAPj/CAD4/wgA+P8IAPj/CQD3/wkA9/8JAPf/CQD3/woA9v8KAPb/CgD2/woA9v8LAP3/CgD//wkA//8IAP//BwD//wYA//8EAP//AwD//wIA//8BAP//AAD+/////v////7////+/////f////3////9//7//f/+//3//v/9//3//f/9//3//f/9//z//f/8//3//P/8//z//P/8//z//P/7//z/+//8//v/+//7//v/+//7//v/+v/7//r/+//6//r/+v/6//r/+f/6//n/+v/5//n/+f/5//n/+P/5//j/+f/4//j/+P/4//j/+P/4//f/+P/3//j/9//3//f/9//3//f/9//3//f/9v/3//b/9//2//b/9v/2//b/9v/2//X/9v/1//b/9f/1//X/9f/1//X/9f/0//X/9P/1//T/9f/0//T/9P/0//T/9P/0//T/9P/0//T/9P/0//T/9P/0//T/9P/0//T/9P/0//T/9P/0//T/9P/0//T/9P/1//T/9f/1//X/9f/1//X/9f/1//b/9f/2//b/9v/2//b/9v/2//f/9v/3//f/9//3//f/9//4//f/+P/4//j/+P/4//j/+f/4//n/+f/5//n/+f/5//r/+f/6//r/+v/6//r/+//6//v/+//7//v/+//7//z/+//8//z//P/8//z//P/9//z//f/9//3//f/9//7//f/+//7//v/+//7///////7////+/////////////////////w==';
      this.audio = new Audio(audioData);
      this.audio.volume = 1.0;
      this.audio.load();
    }

    initializeAudio() {
      if (this.audioInitialized) return Promise.resolve(true);

      return new Promise((resolve) => {
        try {
          this.audio.volume = 0.01;
          const playPromise = this.audio.play();
          
          if (playPromise !== undefined) {
            playPromise
              .then(() => {
                this.audio.pause();
                this.audio.currentTime = 0;
                this.audio.volume = 1.0;
                this.audioInitialized = true;
                
                
                if (this.pendingSound) {
                  this.pendingSound = false;
                  setTimeout(() => this.playNotificationSound(), 100);
                }
                resolve(true);
              })
              .catch((error) => {
                console.warn('⚠️ Audio init failed:', error.message);
                resolve(false);
              });
          } else {
            resolve(false);
          }
        } catch (error) {
          console.warn('⚠️ Audio setup failed:', error);
          resolve(false);
        }
      });
    }

    isSupported() {
      return 'Notification' in window && messaging !== null && 'serviceWorker' in navigator;
    }

    async requestPermission() {
      if (!this.isSupported()) {
        
        return false;
      }

      if (Notification.permission === 'granted') {
        
        return true;
      }

      if (Notification.permission === 'denied') {
        alert('❌ Notifications blocked. Enable in browser settings:\n\n1. Click lock icon\n2. Allow notifications\n3. Reload page');
        return false;
      }

      try {
        const permission = await Notification.requestPermission();
        if (permission === 'granted') {
          await this.initializeAudio();
        }
        return permission === 'granted';
      } catch (error) {
        console.error('❌ Permission error:', error);
        return false;
      }
    }

    // ✅ IMPROVED: Refresh token if stored token is invalid
    async getNotificationToken(restaurantId) {
      try {
        if (!this.isSupported()) {
          
          return null;
        }

        // ✅ CHECK IF STORED TOKEN IS STILL VALID
        const restaurantRef = doc(db, 'restaurants', restaurantId);
        const restaurantSnap = await getDoc(restaurantRef);
        
        if (restaurantSnap.exists()) {
          const storedToken = restaurantSnap.data().fcmToken;
          const tokenUpdatedAt = restaurantSnap.data().fcmTokenUpdatedAt;
          
          // If token was invalidated recently, force refresh
          const invalidatedAt = restaurantSnap.data().fcmTokenInvalidatedAt;
          if (invalidatedAt) {
            const invalidatedTime = new Date(invalidatedAt).getTime();
            const now = Date.now();
            
            // If invalidated less than 1 hour ago, force new token
            if (now - invalidatedTime < 3600000) {
              
              await this.forceTokenRefresh(restaurantId);
            }
          }
          
          // If token exists and was updated recently, reuse it
          if (storedToken && tokenUpdatedAt) {
            const tokenAge = Date.now() - new Date(tokenUpdatedAt).getTime();
            const ONE_DAY = 24 * 60 * 60 * 1000;
            
            if (tokenAge < ONE_DAY) {
              
              this.token = storedToken;
              return storedToken;
            }
          }
        }

        // Get new token
        const hasPermission = await this.requestPermission();
        if (!hasPermission) return null;

        
        const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js', {
          scope: '/',
          updateViaCache: 'none'
        });

        
        await navigator.serviceWorker.ready;

        
        const token = await getToken(messaging, {
          vapidKey: this.vapidKey,
          serviceWorkerRegistration: registration
        });

        if (token) {
          
          this.token = token;

          if (restaurantId) {
            await this.saveTokenToFirestore(restaurantId, token);
          }

          return token;
        } else {
          
          return null;
        }
      } catch (error) {
        console.error('❌ Error getting token:', error);
        
        // ✅ If token retrieval fails, try to refresh
        if (error.code === 'messaging/token-unsubscribe-failed') {
          
          return await this.forceTokenRefresh(restaurantId);
        }
        
        return null;
      }
    }

    // ✅ NEW: Force token refresh
    async forceTokenRefresh(restaurantId) {
      try {
        
        
        // Delete old token
        if (messaging) {
          try {
            await deleteToken(messaging);
            
          } catch (error) {
            console.warn('⚠️ Could not delete old token:', error);
          }
        }

        // Clear from Firestore
        if (restaurantId) {
          const restaurantRef = doc(db, 'restaurants', restaurantId);
          await updateDoc(restaurantRef, {
            fcmToken: null,
            fcmTokenUpdatedAt: null
          });
        }

        // Get new token
        await new Promise(resolve => setTimeout(resolve, 1000)); // Wait 1 second
        return await this.getNotificationToken(restaurantId);
      } catch (error) {
        console.error('❌ Error refreshing token:', error);
        return null;
      }
    }

    async saveTokenToFirestore(restaurantId, token) {
      try {
        const restaurantRef = doc(db, 'restaurants', restaurantId);
        await updateDoc(restaurantRef, {
          fcmToken: token,
          fcmTokenUpdatedAt: new Date().toISOString(),
          fcmTokenInvalidatedAt: null // Clear invalidation flag
        });
        
      } catch (error) {
        console.warn('⚠️ Token not saved:', error);
      }
    }

    async removeToken(restaurantId) {
      if (!restaurantId) return;

      try {
        // Delete from FCM
        if (messaging && this.token) {
          await deleteToken(messaging);
        }
        
        // Remove from Firestore
        const restaurantRef = doc(db, 'restaurants', restaurantId);
        await updateDoc(restaurantRef, {
          fcmToken: null,
          fcmTokenUpdatedAt: null
        });
        
        this.token = null;
        
      } catch (error) {
        console.error('❌ Error removing token:', error);
      }
    }

    setupForegroundListener(callback) {
      if (!messaging) return;

      

      onMessage(messaging, (payload) => {
        
        this.playNotificationSound();

        if (Notification.permission === 'granted') {
          const { title, body, icon } = payload.notification || {};
          
          const notification = new Notification(title || '🔔 New Order!', {
            body: body || 'You have a new order!',
            icon: icon || '/logo192.png',
            badge: '/logo192.png',
            tag: 'order-' + Date.now(),
            requireInteraction: true,
            vibrate: [200, 100, 200, 100, 200],
            silent: false
          });

          setTimeout(() => notification.close(), 15000);

          notification.onclick = (e) => {
            e.preventDefault();
            window.focus();
            notification.close();
          };
        }

        if (callback) callback(payload);
      });
    }

    playNotificationSound() {
      if (!this.audioInitialized) {
        
        this.pendingSound = true;
        this.playFallbackSound();
        return;
      }

      try {
        if (this.audio) {
          this.audio.currentTime = 0;
          this.audio.volume = 1.0;
          
          const playPromise = this.audio.play();
          
          if (playPromise !== undefined) {
            playPromise
              .then(() => console.log('🔔 Sound played'))
              .catch((error) => {
                console.warn('⚠️ Play failed:', error.message);
                this.playFallbackSound();
              });
          }
        }
      } catch (error) {
        console.error('❌ Sound error:', error);
        this.playFallbackSound();
      }
    }

    playFallbackSound() {
      try {
        const audioContext = new (window.AudioContext || window.webkitAudioContext)();
        const oscillator = audioContext.createOscillator();
        const gainNode = audioContext.createGain();

        oscillator.connect(gainNode);
        gainNode.connect(audioContext.destination);

        oscillator.frequency.value = 800;
        oscillator.type = 'sine';
        
        gainNode.gain.setValueAtTime(0.5, audioContext.currentTime);
        gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.5);

        oscillator.start(audioContext.currentTime);
        oscillator.stop(audioContext.currentTime + 0.5);

        
      } catch (error) {
        console.warn('⚠️ Fallback failed:', error);
      }
    }

    vibrate() {
      if ('vibrate' in navigator) {
        navigator.vibrate([200, 100, 200]);
      }
    }

    async testNotification() {
      if (Notification.permission === 'granted') {
        new Notification('✅ Test Notification', {
          body: 'Notifications working!',
          icon: '/logo192.png',
          requireInteraction: false
        });
        this.playNotificationSound();
        this.vibrate();
      }
    }
  }

  export default new NotificationService();